
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`/charge-items/${this.$route.query.id}`).then(res => {
        this.form = {
          ...res.data,
          units: res.data.recordUnits.map(r => r.id),
          incoterms: res.data.incoterms.map(r => r.id)
        }
      })
    },
    save() {
      let data = {
        ...this.form,
        incoterms: this.form.incoterms.map(i => ({ id: i })),
        recordUnits: this.form.units.map(u => ({ id: u }))
      }
      delete data.units
      console.log(data)
      this.$http.put(`/charge-items/${this.$route.query.id}`, data).then(() => {
        this.$router.go(-1)
      })
    },
    remove() {
      this.$http.delete(`/charge-items/${this.$route.query.id}`).then(() => {
        this.$router.go(-1)
      })
    }
  }
}
</script>
